module.exports = __webpack_public_path__ + "static/media/happy-customer.50f473fb.png";